module.exports = __webpack_public_path__ + "static/ballerinatowel-dde8cff40845531ff2bab23c51a2b871.jpeg";